import React, { useContext } from 'react'
import { AppContext } from '../../store'
import './style.scss'
import logoCircuito from '../../assets/images/logo_circuito.png'
import maskGroup from '../../assets/images/mask_group.png'
import womanDesktop from '../../assets/images/woman_desktop.png'
import womanMobile from '../../assets/images/woman_mobile.png'

export default function SectionCircuit() {
	const { state } = useContext(AppContext)
	const { contentful } = state
	const { team: { fields = {} } = {} } = contentful || {}

	return (
		fields.circuit_section ? <section className="container-section-circuit" style={{background: fields.circuit_section_background_color}}>
			<section className="content-container">
				<div className="images-container">
					<img className="mask-img" src={maskGroup} alt="Imagem de fundo" />
					<img className="woman-desktop" src={womanDesktop} alt="Mulher e celular" />
					<div>
						<img className="woman-mobile" src={womanMobile} alt="Mulher" />
					</div>
				</div>

				<div className="text-container">
					<img className="circuit-logo" src={logoCircuito} alt="Logo circuito" />
					<h2>
						<strong>Quem adquire Veloe concorre a prêmios</strong> diários e ainda participa do sorteio de um carro 0km com 1 ano de tanque cheio.
					</h2>
					<h3>É bem fácil! Depois de se tornar cliente Veloe, você recebe um e-mail pra participar da promoção.</h3>
				</div>
			</section>
			<p className="disclaimer">Prêmios em pontos Livelo, autorização SECAP/ME nº 05.015253/2021. Prêmio relativo ao carro 0KM + tanque cheio, Processo SUSEP 15414.618761/2021-61, Bradesco Cap. S.A., CNPJ/ME nº 33.010.851/0001-74. Consulte os Regulamentos no Site: www.circuitoveloe.com.br</p>
		</section> :
		('')
	)
}